import React from 'react'
import {
  Route,
  RouterProvider,
  createRoutesFromElements,
  createBrowserRouter
} from 'react-router-dom'
import App from './App'
import { SigninCapture } from '@/lib/stsAuthProvider'

const routeDefinitions = createRoutesFromElements(
  <Route>
    <Route path="/" element={<App />} />
    <Route path="/signin-oidc" element={<SigninCapture />} />
  </Route>
)

const router = createBrowserRouter(routeDefinitions)

export default function AppRouter() {
  return <RouterProvider router={router} />
}
